export default __webpack_public_path__ + "img/BbUpcCiO.30e040bb.svg";